
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class=" p-2">
      <span class="box-title mr-2">Oficina: </span>
      <span class="box-subtitle">{{informacion?.oficina}}</span>
    </div>

    <div class=" p-2">
      <span class="box-title">Producto: </span>
      <span class="box-subtitle mr-2">{{ informacion?.producto }}</span>
    </div>
    <div class=" p-2">
      <span class="box-title">Monto: </span>
      <span class="box-subtitle mr-2">{{ montoDeposito| currency }}</span>
    </div>
  </div>


  <ul class="list-group list-group-flush">
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Interes a recibir
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span>{{ informacion?.tasa }}%</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Total a recibir
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span class="box-subtitle">{{ informacion?.totalRecibir|currency }}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Plazo en Días
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span>{{ informacion?.plazoDias }}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        DPF Endosado
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span class="box-subtitle">{{ informacion?.dpfEndosado }}</span>
    </li>

  </ul>
</div>





